// src/stone/illustrations/SoftwaresIllustration.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var SoftwaresIllustration = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 64 64",
    ...props,
    children: [
      /* @__PURE__ */ jsx("rect", { width: 64, height: 64, fill: "#E8FEF3", rx: 4 }),
      /* @__PURE__ */ jsx(
        "rect",
        {
          width: 13.631,
          height: 13.631,
          x: 18.4,
          y: 26.225,
          fill: "#00A868",
          rx: 2.75,
          transform: "rotate(11.655 18.4 26.225)"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1D232A",
          d: "M19.355 31.216a2.75 2.75 0 0 1 3.992-1.204l7.24 4.614-1.034 5.008a2.75 2.75 0 0 1-3.249 2.138l-7.314-1.509a2.75 2.75 0 0 1-1.958-3.808z"
        }
      ),
      /* @__PURE__ */ jsx(
        "rect",
        {
          width: 13.631,
          height: 13.631,
          x: 15.32,
          y: 25.589,
          fill: "#00D483",
          rx: 2.75,
          transform: "rotate(11.655 15.32 25.589)"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1D232A",
          d: "m28.033 31.424 2.869 1.662-.106.514-2.869-1.663zM27.822 32.451l2.87 1.663-.107.513-2.869-1.662z"
        }
      ),
      /* @__PURE__ */ jsx(
        "rect",
        {
          width: 13.631,
          height: 13.631,
          x: 21.461,
          y: 10.634,
          fill: "#00A868",
          rx: 2.75,
          transform: "rotate(11.655 21.46 10.634)"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1D232A",
          d: "M22.416 15.626a2.75 2.75 0 0 1 3.991-1.204l7.24 4.614-1.033 5.008a2.75 2.75 0 0 1-3.25 2.138l-7.314-1.509a2.75 2.75 0 0 1-1.958-3.808z"
        }
      ),
      /* @__PURE__ */ jsx(
        "rect",
        {
          width: 13.631,
          height: 13.631,
          x: 18.381,
          y: 9.998,
          fill: "#00D483",
          rx: 2.75,
          transform: "rotate(11.655 18.38 9.998)"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1D232A",
          d: "m31.094 15.833 2.869 1.662-.106.514-2.87-1.663zM30.883 16.86l2.869 1.663-.106.513-2.87-1.662z"
        }
      ),
      /* @__PURE__ */ jsx(
        "rect",
        {
          width: 13.631,
          height: 13.631,
          x: 38.084,
          y: 21.992,
          fill: "#00A868",
          rx: 2.75,
          transform: "rotate(11.655 38.084 21.992)"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1D232A",
          d: "M39.035 26.985a2.75 2.75 0 0 1 3.992-1.204l7.239 4.614-1.033 5.008a2.75 2.75 0 0 1-3.249 2.138l-7.315-1.51a2.75 2.75 0 0 1-1.958-3.808z"
        }
      ),
      /* @__PURE__ */ jsx(
        "rect",
        {
          width: 13.631,
          height: 13.631,
          x: 35.004,
          y: 21.356,
          fill: "#00D483",
          rx: 2.75,
          transform: "rotate(11.655 35.004 21.356)"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1D232A",
          d: "m47.717 27.191 2.869 1.663-.106.513-2.87-1.662zM47.506 28.219l2.869 1.662-.106.514-2.87-1.663z"
        }
      ),
      /* @__PURE__ */ jsx(
        "rect",
        {
          width: 13.631,
          height: 13.631,
          x: 35.059,
          y: 37.897,
          fill: "#00A868",
          rx: 2.75,
          transform: "rotate(11.655 35.059 37.897)"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1D232A",
          d: "M36.011 42.89a2.75 2.75 0 0 1 3.992-1.204l7.24 4.614-1.034 5.008a2.75 2.75 0 0 1-3.248 2.138l-7.315-1.509a2.75 2.75 0 0 1-1.958-3.808z"
        }
      ),
      /* @__PURE__ */ jsx(
        "rect",
        {
          width: 13.631,
          height: 13.631,
          x: 31.977,
          y: 37.262,
          fill: "#00D483",
          rx: 2.75,
          transform: "rotate(11.655 31.977 37.262)"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1D232A",
          d: "m44.69 43.096 2.868 1.662-.106.514-2.868-1.663zM44.48 44.123l2.87 1.662-.107.514-2.868-1.663z"
        }
      )
    ]
  }
);
var SoftwaresIllustration_default = SoftwaresIllustration;

export {
  SoftwaresIllustration_default
};
